import { render, staticRenderFns } from "./ToolPanel.vue?vue&type=template&id=2879ba68&scoped=true"
import script from "./ToolPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolPanel.vue?vue&type=style&index=0&id=2879ba68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879ba68",
  null
  
)

export default component.exports